/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_DescriptionInputs */

const en_dropbox_description = /** @type {(inputs: Dropbox_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose files from your Dropbox to add to your Listening library.`)
};

const es_dropbox_description = /** @type {(inputs: Dropbox_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige archivos de tu Dropbox para añadirlos a tu biblioteca de Listening.`)
};

/**
* | output |
* | --- |
* | "Choose files from your Dropbox to add to your Listening library." |
*
* @param {Dropbox_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_description = /** @type {((inputs?: Dropbox_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_description(inputs)
	return en_dropbox_description(inputs)
});